import Vue from 'vue'
import VueRouter from 'vue-router'
import firebase from 'firebase/app'
import 'firebase/auth'

Vue.use(VueRouter)

  const routes = [
    {
      path: "/",
      name: "home",
      component: () =>
        import(/* webpackChunkName: "Home" */ "@/views/Home.vue"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/profile",
      name: "profile",
      component: () =>
        import(/* webpackChunkName: "Profile" */ "@/views/Profile.vue"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/terms",
      name: "terms",
      component: () =>
        import(/* webpackChunkName: "Terms" */ "@/views/Terms.vue"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/payment",
      name: "payment",
      component: () =>
        import(/* webpackChunkName: "Payment" */ "@/views/Payment.vue"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/success",
      name: "success",
      component: () =>
        import(/* webpackChunkName: "Success" */ "@/views/Success.vue"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/logout",
      name: "logout",
      component: () =>
        import(/* webpackChunkName: "Logout" */ "@/views/Logout.vue"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/login",
      name: "login",
      component: () =>
        import(/* webpackChunkName: "Login" */ "@/views/Login.vue"),
    },
  ];


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const currentUser = firebase.auth().currentUser
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth)

  if (requiresAuth && !currentUser) {
    next("login")
  } else {
    next()
  }
})

export default router
